import { BaseShippingController } from './index';

const RADIX = 10;
const NEW_ADDRESS_VAL = 'new_address';
const NEW_ADDRESS_INT = -1;
const NEW_PAYMENT_METHOD_VAL = 'new_payment';
const NEW_PAYMENT_METHOD_INT = -1;
const SEL_SHIPPING_SVC_RBTN = 'shippingServiceRadioBtn';
const SEL_INSURANCE_CHECKBOX = 'insuranceCheckbox';
const SEL_SIGNATURE_CHECKBOX = 'signatureCheckbox';
const SEL_SHIPPING_ADDRESS_RBTN = 'shippingAddressRadioBtn';
const SEL_PAYMENT_METHOD_RBTN = 'paymentMethodRadioBtn';
const SEL_LOADING_MODAL = '#shipping-change-section';
const SEL_LOCAL_PICK_POPUP = '#local-popup';
const TARGET_INSURANCE_DISPLAY_PRICE = 'insuranceDisplayPrice';
const TARGET_SIGNATURE_DISPLAY_PRICE = 'signatureDisplayPrice';
const TARGET_SUMMARY_SHIPPING_FEE = 'summaryShippingFee';
const TARGET_SUMMARY_ADDITIONAL_COSTS = 'summaryAdditionalCosts';
const TARGET_SUMMARY_ROUNDUP_SUBTOTAL = 'summaryRoundupSubtotal';
const TARGET_SUMMARY_FINAL_TOTAL = 'summaryFinalTotal';
const TARGET_TAX_DESCRIPTION = 'summaryTaxDescription';
const TARGET_DISCOUNT = 'summaryDiscount';
const TARGET_TAX_TOTAL = 'summaryTaxTotal';
const IN_CENTS_I = 100;
const IN_CENTS_F = 100.0;
const PARAM_SHIPPING_RATES = 'shippingRates';

function _serviceCodeToValue(serviceCode) {
  const _map = {
    'ups_ground': 'ups',
    'fedex_home_delivery': 'fedex',
    'free_shipping': 'free_shipping'
  };
  return _map[serviceCode] || serviceCode;
}

function _valueToServiceCode(value) {
  const _map = {
    'ups': 'ups_ground',
    'fedex': 'fedex_home_delivery',
    'free_shipping': 'free_shipping'
  };
  return _map[value] || value;
}

export default class extends BaseShippingController {
  static values = {
    url: String,
    ratesUrl: String
  }

  connect() {
    const fetchUrl = this.buildFetchUrl(this.ratesUrlValue);
    this.showLoadingModal(SEL_LOADING_MODAL);
    this.fetchJson(fetchUrl).then(data => {
      console.log("Shipping Rates from Server:", data);
      if (!data || !data.rates) {
        this.hideLoadingModal(SEL_LOADING_MODAL);
        return;
      }
      // Update only the shipping rates display based on the data.rates object.
      this._updateShippingCardDisplayPrices(data.rates);

      const selectedValues = this._collectFormState({});
      const selectedSvc = selectedValues.shippingSvc;
      const rate = data.rates[_valueToServiceCode(selectedSvc)] || { shipmentCost: 0.0, otherCost: 0.0, displayCost: '$0.00' };

      // Update the shipping fee display element using the returned rate.
      $(`[data-shipping-target="${TARGET_SUMMARY_SHIPPING_FEE}"]`).text(rate.displayCost);

      // Update the hidden field for charged shipping cost.
      const combinedShippingCost = rate.shipmentCost + rate.otherCost;
      this._updateChargedShippingCost(combinedShippingCost);
      this._formChanged(null, true);

      // Hide the loading modal.
      this.hideLoadingModal(SEL_LOADING_MODAL);
    });
  }

  shippingServiceChanged(event) {
    this._formChanged(event, false);
  }

  insuranceSwitchChanged(event) {
    this._formChanged(event);
  }

  signatureServiceChanged(event) {
    this._formChanged(event);
  }

  shippingAddressChanged(event) {
    $('.address-selected').removeClass('address-selected bg-yellow-50 bg-opacity-50');
    event.target.closest('label').className += ' address-selected bg-yellow-50 bg-opacity-50';
    this._formChanged(event, true);
  }

  paymentMethodChanged(event) {
    $('.payment-source-selected').removeClass('payment-source-selected border border-yellow-500');
    event.target.closest('label').className += ' payment-source-selected border border-yellow-500';
    this._formChanged(event);
  }

  _formChanged(event, fetchNewRates = false) {
    const currentValues = this._collectFormState(event);
    let params = {
      shippingSpec: JSON.stringify(currentValues)
    };

    let _shipmentCostCents, _otherCostCents;
    if (currentValues.shippingSvc === 'free_shipping') {
      _shipmentCostCents = 0;
      _otherCostCents = 0;
    } else {
      const parsedShipment = parseInt(
        $(`.${currentValues.shippingSvc}-shipping-cost[data-shipment-cost-cents]`)
          .attr('data-shipment-cost-cents'), RADIX
      );
      const parsedOther = parseInt(
        $(`.${currentValues.shippingSvc}-shipping-cost[data-other-cost-cents]`)
          .attr('data-other-cost-cents'), RADIX
      );
      _shipmentCostCents = isNaN(parsedShipment) ? 0 : parsedShipment;
      _otherCostCents = isNaN(parsedOther) ? 0 : parsedOther;
    }

    params[PARAM_SHIPPING_RATES] = btoa(JSON.stringify({
      fetchNewRates,
      shippingSvc: currentValues.shippingSvc,
      shipmentCostCents: _shipmentCostCents,
      otherCostCents: _otherCostCents,
    }));

    const fetchUrl = this.buildFetchUrl(this.urlValue, params);
    this.showLoadingModal(SEL_LOADING_MODAL);
    this.fetchJson(fetchUrl).then(data => {
      console.log("Basket Totals from Server:", data);
      if (!data) {
        if (fetchNewRates) {
          this.hideLoadingModal(SEL_LOADING_MODAL);
        }
        return;
      }
      this._updateDisplayValues(data, fetchNewRates);
      this._updateChargedValues(data);
      this.hideLoadingModal(SEL_LOADING_MODAL);
      this._updateShippingPriceClasses(data.summary.shippingService);
      if (data.summary.shippingService === 'local_pickup') {
        $(SEL_LOCAL_PICK_POPUP).show();
      }
    });
  }

  _updateShippingPriceClasses(shippingService) {
    const targets = {
      ups: '[data-shipping-target="upsDisplayPrice"]',
      fedex: '[data-shipping-target="fedexDisplayPrice"]',
      localPickup: '[data-shipping-target="localPickupDisplayPrice"]',
      freeShipping: '[data-shipping-target="freeShippingDisplayPrice"]'
    };

    // Reset
    $(targets.ups).removeClass("font-medium text-gray-900").addClass("text-gray-500");
    $(targets.fedex).removeClass("font-medium text-gray-900").addClass("text-gray-500");
    $(targets.localPickup).removeClass("font-medium text-gray-900").addClass("text-gray-500");
    $(targets.freeShipping).removeClass("font-medium text-gray-900").addClass("text-gray-500");

    switch (shippingService) {
      case 'ups':
        $(targets.ups).addClass("font-medium text-gray-900");
        break;
      case 'fedex':
        $(targets.fedex).addClass("font-medium text-gray-900");
        break;
      case 'local_pickup':
        $(targets.localPickup).addClass("font-medium text-gray-900");
        break;
      case 'free_shipping':
        $(targets.freeShipping).addClass("font-medium text-gray-900");
        break;
      default:
        break;
    }
  }

  _updateShippingCardDisplayPrices(newRates) {
    $.each(newRates, (serviceCode, rate) => {
      const frontEndSvcId = _serviceCodeToValue(serviceCode);
      $(`.${frontEndSvcId}-shipping-cost`).text(rate.displayCost);
      $(`.${frontEndSvcId}-shipping-cost`).attr({
        'data-shipment-cost-cents': Math.round(rate.shipmentCost * IN_CENTS_I),
        'data-other-cost-cents': Math.round(rate.otherCost * IN_CENTS_I)
      });
    });
  }

  _updateDisplayValues(data, newRates = false) {
    $(`[data-shipping-target="${TARGET_INSURANCE_DISPLAY_PRICE}"]`)
      .text(data.insurance.displayPrice);
    const insurancePriceElement = $(`[data-shipping-target="${TARGET_INSURANCE_DISPLAY_PRICE}"]`);
    this.updatePriceDisplay(insurancePriceElement, data.insurance.displayPrice);

    $(`[data-shipping-target="${TARGET_SIGNATURE_DISPLAY_PRICE}"]`)
      .text(data.signature.displayPrice);
    const signaturePriceElement = $(`[data-shipping-target="signatureDisplayPrice"]`);
    this.updatePriceDisplay(signaturePriceElement, data.signature.displayPrice);

    $(`[data-shipping-target="${TARGET_SUMMARY_SHIPPING_FEE}"]`)
      .text(data.summary.shippingFeeDisplayPrice);
    $(`[data-shipping-target="${TARGET_SUMMARY_ADDITIONAL_COSTS}"]`)
      .text(data.summary.additionalCostsDisplayPrice);
    $(`[data-shipping-target="${TARGET_SUMMARY_ROUNDUP_SUBTOTAL}"]`)
      .text(data.summary.roundupSubtotalDisplayPrice);
    $(`[data-shipping-target="${TARGET_SUMMARY_FINAL_TOTAL}"]`)
      .text(data.summary.finalTotalDisplayPrice);
    $(`[data-shipping-target="${TARGET_TAX_DESCRIPTION}"]`)
      .text(data.summary.TaxDescription);
    $(`[data-shipping-target="${TARGET_TAX_TOTAL}"]`)
      .text(data.summary.stateTaxDisplayPrice);
    $(`[data-shipping-target="${TARGET_DISCOUNT}"]`)
      .text('-' + data.summary.promotionalCredits);

    if (data.summary.TaxAmount === 0) {
      const taxElement = this.element.querySelector(`[data-shipping-target="${TARGET_TAX_TOTAL}"]`);
      const descriptionElement = this.element.querySelector(`[data-shipping-target="${TARGET_TAX_DESCRIPTION}"]`);
      taxElement.style.display = "none";
      descriptionElement.style.display = "none";
    } else {
      const taxElement = this.element.querySelector(`[data-shipping-target="${TARGET_TAX_TOTAL}"]`);
      const descriptionElement = this.element.querySelector(`[data-shipping-target="${TARGET_TAX_DESCRIPTION}"]`);
      if (taxElement != 'undefined' && descriptionElement != 'undefined') {
        taxElement.style.display = "";
        descriptionElement.style.display = "";
      }
    }
    if (newRates) {
      this._updateShippingCardDisplayPrices(data.newRates);
    }
  }

  updatePriceDisplay(element, price) {
    if (price === '$0.00') {
      element.removeClass("text-gray-900").addClass("text-gray-500");
    } else {
      element.removeClass("text-gray-500").addClass("text-gray-900");
    }
  }

  _updateChargedValues(data) {
    let totalShippingCost = 0;
    if('newRates' in data) {
      const selectedShippingRates = data.newRates[_valueToServiceCode(data.summary.shippingService)];
      totalShippingCost = selectedShippingRates.totalCostCents / IN_CENTS_F;
    } else {
      const $selectedShippingCostElem =
        $(`label:has(input[data-shipping-target="${SEL_SHIPPING_SVC_RBTN}"]:checked)`)
          .find('[data-shipment-cost-cents]');

       const shipmentCostCents = parseInt($selectedShippingCostElem.attr('data-shipment-cost-cents'), 10);
       const otherCostCents = parseInt($selectedShippingCostElem.attr('data-other-cost-cents'), 10);

      totalShippingCost = (shipmentCostCents + otherCostCents) / IN_CENTS_F;
    }

    this._updateChargedShippingCost(totalShippingCost);
    this._updateChargedInsuranceCost(data.insurance.priceCents / IN_CENTS_F);
    this._updateChargedSignatureCost(data.signature.priceCents / IN_CENTS_F);
    this._updateInsuranceToggle(data.insurance.insuranceValue);
    this._updateSignatureToggle(data.signature.signatureValue);
  }

  _collectFormState(event) {
    const IS_CHECKBOX = true;
    const addressIdVal = this._formValue(SEL_SHIPPING_ADDRESS_RBTN);
    const paymentMethodIdVal = this._formValue(SEL_PAYMENT_METHOD_RBTN);
    return {
      shippingSvc: this._formValue(SEL_SHIPPING_SVC_RBTN),
      insurance: !!this._formValue(SEL_INSURANCE_CHECKBOX, IS_CHECKBOX),
      signature: !!this._formValue(SEL_SIGNATURE_CHECKBOX, IS_CHECKBOX),
      addressId: addressIdVal === NEW_ADDRESS_VAL
        ? NEW_ADDRESS_INT
        : parseInt(addressIdVal, RADIX),
      paymentMethodId: paymentMethodIdVal === NEW_PAYMENT_METHOD_VAL
        ? NEW_PAYMENT_METHOD_INT
        : parseInt(paymentMethodIdVal, RADIX)
    };
  }

  _formValue(targetStr, isCheckbox = false) {
    return $(`[data-shipping-target="${targetStr}"]:checked`).val();
  }

  _updateChargedShippingCost(value) {
    $('#shipping_request_charged_shipping_cost').val(value);
  }

  _updateChargedInsuranceCost(value) {
    $('#shipping_request_charged_insurance_cost').val(value);
  }

  _updateChargedSignatureCost(value) {
    $('#shipping_request_charged_signature_cost').val(value);
  }

  _updateInsuranceToggle(value) {
    $('#shipping_request_insurance').prop('checked', value);
  }

  _updateSignatureToggle(value) {
    $('#shipping_request_signature').prop('checked', value);
  }
}
